import API from './request'; // 加载平台接口封装
export const ExecutionFeedbackServer = {
    feedbackUse: (activityCode) => API.get(`/feedback/user/${activityCode}`),
    feedbackOptions: () => API.post('/feedback/options'),
    feedback: (params) => API.post('/feedback/', params),
    verificationFeedback: (params) => API.post('compliance-verification/feedback', params),
    feedbackList: (activityCode) => API.get(`/feedback/list/${activityCode}`),
    getSalesmanList: (params) => API.get(`/config/salesman/list/10/${params}`), // 获取申请人列表
    feedbackOne: (feedbackId) => API.get(`/feedback/one/${feedbackId}`),
    queryMyFeedback: (activityCode) => API.get(`/feedback/my/${activityCode}`),
    feedbackQdName: (params) => API.post(`/config/qd/name`, params),
    customerExist: (activityCode) => API.get(`/customer/CustomerExist/${activityCode}`)
};